export default __webpack_public_path__ + "static/media/step-4.d944f507.webp";